/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios";
import { Agente } from "../agentes/useAgentesAPI";
import useApi, { ActionResult, Api, Model, Query, Response } from "../common/hooks/useApi"
import { FilterReincidenciaProps } from "../infracciones/hooks/useInfraccionesAPI";

export enum TipoImpresionRadar {
    NO_IMPRIME = 0,
    ACTA_IMPORTADA = 1,
    ACTA_MISIONES = 2
};

export interface EmpresaCorreo {
    id: string
    nombre: string
}

export interface LoteImpresion extends Model {
    NroLote: string
    FechaHora: string
    UrlLoteComprimido?: string
    CantidadInfracciones: number
    CantidadInfraccionesExcluidas: number
    CantidadInfraccionesRegeneradas: number
    TipoImpresionRadar: TipoImpresionRadar
    AgenteFirmante?: Agente
    EmpresaCorreo?: string
    UnidadesProdNombre?: string
    DisponibleCallcenter?: boolean
    FechaHoraCallCenter?: string
}

export interface RegenerarModel {
    file: FormData    
}

const module = "LoteImpresion";

export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<LoteImpresion>(query),
        save: (data: Partial<LoteImpresion>) => api.save!<Partial<LoteImpresion>, LoteImpresion>(data),
        delete: (id: number) => api.delete(id),
        generateLote: async (query: Query, excluidasId?: number | number[], agenteFirmanteId?: number, empresaCorreoId?: number, infraccionesId?: number[], unidadesProd?: string[]): Promise<ActionResult<string | string[]>> => {
            try {
                let qs = api.queryToString(query);
                //const unidadesProdNombresString = unidadesProd?.join(',');
                
                const data = {
                    "ExcluidasId":excluidasId,
                    "infraccionesId":infraccionesId,
                    "unidadesProdNombres":unidadesProd,
                    "AgenteId":agenteFirmanteId,
                    "EmpresaCorreoId":empresaCorreoId
                }

                const response = await api
                    .axiosInstance
                    .post<string | string[]>(`${module}/Generar?${qs}`, data);
                return {
                    data: {
                        value: response.data
                    }
                };
            } catch (error: any | AxiosError) {

                return {
                    error
                };
            }
        },
        importPDF: async (tipoImportacion: string) => {
            try {
                await api.axiosInstance.post(`${module}/ImportarActas/${tipoImportacion}`);
                return {
                    data: { value: undefined },
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        downloadPrinter: async () => {
            try {
                const response = await api.axiosInstance.get<Response<string>>(`${module}/DescargarImpresor`);
                return {
                    data: { value: response.data.value },
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        getTemplates: async () => {
            try {
                const response = await api.axiosInstance.get<Response<string[]>>(`${module}/VerTemplates()`);
                return {
                    data: { value: response.data.value }
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }

        },
        getEmpresasCorreo: async () => {
            try {
                const response = await api.axiosInstance.get<Response<string[]>>(`TipoEmpresaEnvio`);
                return {
                    data: { value: response.data.value }
                }
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }

        },
        sendLoteImpresionToCallCenter: async (loteImpresionId: number) => {
            try {
                await api.axiosInstance.post(`${module}/DisponibleCallcenter?loteId=${loteImpresionId}`);
                return {
                    data: { value: undefined },
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        getActaPdf: async (idInfraccion: number) => {
            try {
                const response = await api.axiosInstance.get<string>(`${module}/Acta/${idInfraccion}`);
                return {
                    data: { value: response.data },
                };
            } catch (error: any | AxiosError) {
                return {
                    error
                };
            }
        },
        sendFile: async (data: FormData) => {
            try {
                const response = await api.axiosInstance.post(`${module}/Convertir/Verificadas`,  data, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                });
                
                if(response.data.length === 0) {throw new Error ('No se procesaron registros...')}

                return { data: response.data, count: response.data.length }                
            } catch (error:any | AxiosError) {                
                throw error;
            }
        },
        getLoteByParameter:async (query: string, soloTxt:boolean, soloPdf:boolean) => {
            const response = await api.axiosInstance.post(`${module}/DescargarPorParametros?${query}`, {soloTxt: soloTxt, soloPdf: soloPdf},  { responseType: 'arraybuffer' });          
            return response;
        }
    }
}